// DS: i3.17.1
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Settings: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M13.22 3a1 1 0 01.97.757l.335 1.342a1 1 0 00.47.623l.942.545a1 1 0 00.776.096l1.33-.38a1 1 0 011.142.461l1.219 2.112a1 1 0 01-.171 1.219l-.955.923a1 1 0 00-.302.796l.018.281L19 12l-.006.225-.018.28a1 1 0 00.302.796l.955.924a1 1 0 01.17 1.22l-1.218 2.11a1 1 0 01-1.141.462l-1.332-.38a1 1 0 00-.775.096l-.943.545a1 1 0 00-.47.623l-.335 1.342a1 1 0 01-.856.75L10.78 21a1 1 0 01-.937-.649l-.368-1.452a1 1 0 00-.469-.62l-.944-.546a1 1 0 00-.775-.096l-1.332.38a1 1 0 01-1.072-.358l-1.288-2.215a1 1 0 01.088-1.127l.083-.092.955-.923a1 1 0 00.302-.796l-.018-.281L5 12l.006-.225.018-.28a1 1 0 00-.302-.796l-.955-.924a1 1 0 01-.226-1.108l1.274-2.223a1 1 0 011.02-.488l1.455.41a1 1 0 00.77-.098l.946-.546a1 1 0 00.47-.623l.335-1.342A1 1 0 0110.78 3h2.438zM12 9a3 3 0 100 6 3 3 0 000-6z"
      />
    </svg>
  </IconWrap>
);
Settings.displayName = 'Settings';

export default Settings;
